<template>
  <div>
    <!-- Research Statistics -->
    <div class="g-mt-minus-70" :class="[{'container-fluid':this.framePageVisible == 'true'}, {'container-fluid':accountType != 'master'}, {'container':this.framePageVisible == 'false'}]">
      <div class="row">
        <div class="col-lg-1 col-div-0" v-if="this.framePageVisible == 'true' || accountType == 'master'"></div>
        <div class="col-sm-6 g-mb-30 g-mb-20--lg" :class="[{'col-lg-2 col-div-4':this.framePageVisible == 'true'},{'col-lg-2 col-div-4':accountType == 'master'},{'col-lg-3':this.framePageVisible == 'false'}]">
          <!-- Research Block -->
          <div class="g-py-10 g-icon-link" v-on:click="RouterRedirect('Order')">
            <div class="u-shadow-v37 rounded-circle g-pos-rel mx-auto" :class="[{'g-width-200 g-height-200':this.framePageVisible == 'true'}, {'g-width-200 g-height-200':accountType == 'master'}, {'g-width-220 g-height-220':this.framePageVisible == 'false'}]">
              <!-- Research - SVG Shape -->
              <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                    viewBox="0 0 187 187" enable-background="new 0 0 187 187" xml:space="preserve">
                <g id="_x31_">
                  <circle fill="#ffffff" cx="93.5" cy="93.5" r="93.5"/>
                  <circle fill="#ffffff" stroke="#f0f2f8" stroke-width="7" stroke-miterlimit="10" cx="93.5" cy="93.5" r="81"/>
                  <path fill="none" stroke="var(--primary-color)" stroke-width="7" stroke-linecap="round" stroke-miterlimit="10" d="M93.5,12.5c26.7,0,50.4,12.9,65.2,32.9"/>
                  <!-- <path fill="none" stroke="var(--primary-color)" stroke-width="7" stroke-linecap="round" stroke-miterlimit="10" d="M93.5,12.5c44.7,0,81,36.3,81,81c0,21.3-8.2,40.6-21.6,55.1,55"/> -->
                </g>
              </svg>
              <!-- End Research - SVG Shape -->

              <!-- Research - Info -->
              <div class="text-center g-absolute-centered--y g-left-0 g-right-0 g-px-35">
                <h4 class="h2 g-font-primary">Patient Order</h4>
              </div>
              <!-- Research - Info -->
            </div>
          </div>
          <!-- End Research Block -->
        </div>

        <div class="col-sm-6 g-mb-30 g-mb-20--lg" :class="[{'col-lg-2 col-div-4':this.framePageVisible == 'true'},{'col-lg-2 col-div-4':accountType === 'master'},{'col-lg-3':this.framePageVisible == 'false'}]">
          <!-- Research Block -->
          <div class="g-py-10 g-icon-link" v-on:click="RouterRedirect('OrderTracking')">
            <div class="u-shadow-v37 rounded-circle g-pos-rel mx-auto" :class="[{'g-width-200 g-height-200':this.framePageVisible == 'true'},{'g-width-200 g-height-200':accountType === 'master'},{'g-width-220 g-height-220':this.framePageVisible == 'false'}]">
              <!-- Research - SVG Shape -->
              <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                    viewBox="0 0 187 187" enable-background="new 0 0 187 187" xml:space="preserve">
                <circle fill="#ffffff" cx="93.5" cy="93.5" r="93.5"/>
                <circle fill="#ffffff" stroke="#f0f2f8" stroke-width="7" stroke-miterlimit="10" cx="93.5" cy="93.5" r="81"/>
                <path fill="none" stroke="var(--primary-color)" stroke-width="7" stroke-linecap="round" stroke-miterlimit="10" d="M93.5,12.5
                  c43,0,78.2,33.6,80.8,75.9"/>
              </svg>
              <!-- End Research - SVG Shape -->

              <!-- Research - Info -->
              <div class="text-center g-absolute-centered--y g-left-0 g-right-0 g-px-35">
                <h4 class="h2 g-font-primary">Track Order</h4>
              </div>
              <!-- Research - Info -->
            </div>
          </div>
          <!-- End Research Block -->
        </div>

        <div class="col-sm-6 col-lg-2 col-div-4 g-mb-30 g-mb-20--lg" v-if="this.framePageVisible == 'true' || accountType == 'master'">
          <!-- Research Block -->
          <!-- 
            Hey John, 
            Just use this line to be able to access frame page.
            <div class="g-py-10 g-icon-link" v-on:click="RouterRedirect('FramesCenter')"> 
          -->
            <div class="g-py-10 g-icon-link" v-on:click="RouterRedirect('FramesCenter')">
            <div class="u-shadow-v37 rounded-circle g-pos-rel mx-auto" :class="[{'g-width-200 g-height-200':this.framePageVisible == 'true'},{'g-width-200 g-height-200':accountType == 'master'},{'g-width-220 g-height-220':this.framePageVisible == 'false'}]">
              <!-- Research - SVG Shape -->
              <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                    viewBox="0 0 187 187" enable-background="new 0 0 187 187" xml:space="preserve">
                <circle fill="#ffffff" cx="93.5" cy="93.5" r="93.5"/>
                <circle fill="#ffffff" stroke="#f0f2f8" stroke-width="7" stroke-miterlimit="10" cx="93.5" cy="93.5" r="81"/>
                <path fill="none" stroke="var(--primary-color)" stroke-width="7" stroke-linecap="round" stroke-miterlimit="10" d="M93.5,12.5c44.7,0,81,36.3,81,81c0,21.3-8.2,40.6-21.6,55.1,55"/>
              </svg>
              <!-- End Research - SVG Shape -->

              <!-- Research - Info -->
              <div class="text-center g-absolute-centered--y g-left-0 g-right-0 g-px-35">
                <h4 class="h2 g-font-primary nomargin">Frame Collection</h4>
                <!--<p v-if="this.framePageVisible == 'true'" style="color: red">Order Now!</p>-->
              </div>
              <!-- Research - Info -->
            </div>
          </div>
          <!-- End Research Block -->
        </div>

        <div class="col-sm-6 g-mb-30 g-mb-20--lg" :class="[{'col-lg-2 col-div-6':this.framePageVisible == 'true'},{'col-lg-2 col-div-6':accountType == 'master'},{'col-lg-3':this.framePageVisible == 'false'}]">
          <!-- Research Block -->
          <div class="g-py-10 g-icon-link" :class="[{'div-left':this.framePageVisible == 'true'},{'div-left':accountType == 'master'}]" v-on:click="RouterRedirect('Resource')">
            <div class="u-shadow-v37 rounded-circle g-pos-rel mx-auto" :class="[{'g-width-200 g-height-200':this.framePageVisible == 'true'},{'g-width-200 g-height-200':accountType == 'master'},{'g-width-220 g-height-220':this.framePageVisible == 'false'}]">
              <!-- Research - SVG Shape -->
              <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                    viewBox="0 0 187 187" enable-background="new 0 0 187 187" xml:space="preserve">
                <circle fill="#ffffff" cx="93.5" cy="93.5" r="93.5"/>
                <circle fill="#ffffff" stroke="#f0f2f8" stroke-width="7" stroke-miterlimit="10" cx="93.5" cy="93.5" r="81"/>
                <path fill="none" stroke="var(--primary-color)" stroke-width="7" stroke-linecap="round" stroke-miterlimit="10" d="M93.5,12.5c44.7,0,81,36.3,81,81s-36.3,81-81,81c-26.3"/> 
              </svg>
              <!-- End Research - SVG Shape -->

              <!-- Research - Info -->
              <div class="text-center g-absolute-centered--y g-left-0 g-right-0 g-px-35">
                <h4 class="h2 g-font-primary">Guides &amp; Resources</h4>
              </div>
              <!-- Research - Info -->
            </div>
          </div>
          <!-- End Research Block -->
        </div>

        <div class="g-mb-30 g-mb-20--lg" :class="[{'col-sm-12 col-lg-2 col-div-6':this.framePageVisible == 'true'},{'col-sm-12 col-lg-2 col-div-6':accountType == 'master'},{'col-sm-6 col-lg-3':this.framePageVisible == 'false'}]">
          <!-- Research Block -->
          <div class="g-py-10 g-icon-link" :class="[{'div-right':this.framePageVisible == 'true'}, {'div-right':accountType == 'master'}]" v-on:click="RouterRedirect('Help')">
            <div class="u-shadow-v37 rounded-circle g-pos-rel mx-auto" :class="[{'g-width-200 g-height-200':this.framePageVisible == 'true'},{'g-width-200 g-height-200':accountType == 'master'},{'g-width-220 g-height-220':this.framePageVisible == 'false'}]">
              <!-- Research - SVG Shape -->
              <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                    viewBox="0 0 187 187" enable-background="new 0 0 187 187" xml:space="preserve">
                <circle fill="#ffffff" cx="93.5" cy="93.5" r="93.5"/>
                <circle fill="#ffffff" stroke="#f0f2f8" stroke-width="7" stroke-miterlimit="10" cx="93.5" cy="93.5" r="81"/>
                <path fill="#ffffff" stroke="var(--primary-color)" stroke-width="7" stroke-linecap="round" stroke-miterlimit="10" d="M93.5,12.5
                  c44.7,0,81,36.3,81,81s-36.3,81-81,81c-26.3,0-49.7-12.6-64.5-32"/>
              </svg>
              <!-- End Research - SVG Shape -->

              <!-- Research - Info -->
              <div class="text-center g-absolute-centered--y g-left-0 g-right-0 g-px-35">
                <h4 class="h2 g-font-primary">FAQs</h4>
              </div>
              <!-- Research - Info -->
            </div>
          </div>
          <!-- End Research Block -->
        </div>
        <div class="col-lg-1 col-div-0" v-if="this.framePageVisible == 'true' || accountType == 'master'"></div>
      </div>
    </div>
    <!-- End Research Statistics -->
  </div>
  
</template>
<script>
export default {
  components: { },
  data(){
      return{
          isLogIn: false,
          IsNavbarShown: true,
          framePageVisible: localStorage.getItem("frameAndLensOrderIsAllowed"),
          kitOrderedYet: localStorage.getItem("IsFrameKitAllowed")          
      }
  },
  methods:{
    RouterRedirect(name){
      this.$router.push({name: name});
    }
  }
}
</script>



// WEBPACK FOOTER //
// HomeIcons.vue?20cf322e